// @app/modules/duck/index.js
import moduleReducer from './reducers';
export { default as moduleOperations } from './operations';
export default moduleReducer;